
import { Component, Prop, Vue } from "vue-property-decorator";
import LevelDetail from "@/views/paper/paper-result-report/component-new-h5/level-detail.vue";
import { CandidateNewResult } from "@/lib/model/exam/candidate-result";

@Component({
  components: { LevelDetail }
})
export default class Mandarin extends Vue {
  // @Prop() index!: number;
  connectCode = "";
  @Prop({ type: CandidateNewResult, default: () => new CandidateNewResult() })
  all!: CandidateNewResult; //候选人信息 所有表
  // @Prop({ type: Candidate, default: () => new Candidate() })
  // candidate!: CandidateResult; //候选人信息 主表

  get colorMap(): Record<number, string> {
    return {
      10: "#FF4137",
      20: "#FF9B00",
      30: "#19C976"
    };
  }

  get getEval() {
    const chinese = this.all.report.chineseAssessmentResult;
    return {
      color: this.colorMap[chinese.score],
      isEmpty: chinese.score === 0,
      desc: chinese.comment,
      text: chinese.levelDesc
    };
  }
}
